import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import useStyles from './styles'

const CircularProgressWithLabel = ({ value, showPercent, size = 70 }) => {
  const classes = useStyles()

  return (
    <Box className={classes.progressWrapp}>
      <CircularProgress
        variant="determinate"
        className={classes.bottom}
        size={size}
        thickness={3}
        value={100}
      />
      <CircularProgress
        variant={showPercent ? 'static' : 'indeterminate'}
        disableShrink={!showPercent}
        className={classes.top}
        size={size}
        thickness={3}
        value={value}
      />
      {showPercent && (
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            className={classes.parcent}
          >{`${Math.round(value)}%`}</Typography>
        </Box>
      )}
    </Box>
  )
}

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
}

export default CircularProgressWithLabel
